import React, { useEffect, useState } from "react";
import Snacky from "../../Shared/Snacky";
import axios from "axios";
import { Skeleton } from "@material-ui/lab";
import BoxesTable from "./BoxesTable";
import { Button, Typography } from "@material-ui/core";
import { connect } from "react-redux";
import { setSnackBarProps } from "../../../reduxActions/snackbar";

const Boxes = ({ snackbar, setSnackBarProps }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [boxes, setBoxes] = useState([]);
  const [isAddingNew, setIsAddingNew] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [updatedBoxes, setUpdatedBoxes] = useState([]);

  useEffect(() => {
    getAllBoxes();
  }, []);

  const getAllBoxes = () => {
    setIsLoading(true);
    axios
      .get(`boxes/GetAllBoxes`)
      .then(({ data }) => {
        setBoxes(data);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setIsLoading(false));
  };

  const handleCreateBlankBox = () => {
    const _newBox = {
      name: "",
      height: 0,
      width: 0,
      length: 0,
      minCapacity: 1,
      maxCapacity: 10,
    };
    setBoxes([_newBox, ...boxes]);
    setIsAddingNew(true);
    setHasChanges(true);
  };

  const batchUpdateBoxesState = (savedBoxes) => {
    let boxesClone = [...boxes];
    savedBoxes.forEach((box) => {
      boxesClone = boxesClone.map((b) => (b.id === box.id || !b.id ? box : b)); // in case pc.id is undefined it replaces with the first box from savedBoxes list. Api returns the new product first.
    });
    setBoxes(boxesClone);
  };

  const handleSaveBox = () => {
    if (updatedBoxes.length > 0) {
      setIsSaving(true);
      axios
        .post(`Boxes/BatchSaveBoxes`, updatedBoxes)
        .then(({ data }) => {
          setIsAddingNew(false);
          setHasChanges(false);
          batchUpdateBoxesState(data);
          setUpdatedBoxes([]);
          setSnackBarProps(
            "success",
            `Fantastic! The boxes have been saved.`,
            true
          );
        })
        .catch((err) => {
          console.log(err);
          setSnackBarProps("warning", `Oops! Unable to save boxes.`, true);
        })
        .finally(() => {
          setIsSaving(false);
        });
    }
  };

  const handleUpdateBoxesChangeList = (box) => {
    const existingBox = updatedBoxes.find((p) => p.id === box.id);
    if (existingBox) {
      setUpdatedBoxes(updatedBoxes.map((p) => (p.id === box.id ? box : p)));
    } else {
      setUpdatedBoxes([...updatedBoxes, box]);
    }
    setHasChanges(true);
  };

  const handleConfirmBoxDeletion = (boxId) => {
    if (boxId) {
      axios
        .delete(`boxes/DeleteBox/${boxId}`)
        .then(() => {
          setBoxes(boxes.filter((b) => b.id !== boxId));
          setSnackBarProps("success", `Done! The box has been deleted.`, true);
        })
        .catch((err) => {
          console.log(err);
          setSnackBarProps("warning", `Oops! Unable to delete box.`, true);
        });
    }
  };

  return (
    <div>
      <Snacky snackprops={snackbar} setSnackBarProps={setSnackBarProps} />
      <div className="products-root">
        {isLoading ? (
          <div className="products-loading-skeleton-container">
            <Skeleton height={50} />
            <Skeleton height={50} />
            <Skeleton height={50} />
          </div>
        ) : (
          <div className="product-results-container">
            <div className="products-actions-container">
              {!isAddingNew && !isSaving && (
                <Button
                  size="small"
                  color="primary"
                  variant="outlined"
                  onClick={(e) => {
                    handleCreateBlankBox();
                  }}
                >
                  Add new box
                </Button>
              )}
              {!isSaving && hasChanges && (
                <Button
                  size="small"
                  variant="outlined"
                  onClick={(e) => {
                    handleSaveBox();
                  }}
                >
                  Save
                </Button>
              )}
            </div>
            {boxes.length > 0 ? (
              <BoxesTable
                boxes={boxes}
                handleUpdateBoxesChangeList={handleUpdateBoxesChangeList}
                handleConfirmBoxDeletion={handleConfirmBoxDeletion}
              />
            ) : (
              <div
                className="producs-paper-container"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  padding: 30,
                }}
              >
                <Typography>
                  <strong>No Box Found</strong>
                </Typography>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  snackbar: state.snackbar,
});

export default connect(mapStateToProps, {
  setSnackBarProps,
})(Boxes);
